// Core
import React from "react"
import styled from "styled-components"

// General Components
import BaseContainer from "../../../../components/BaseContainer"

// Components
import CopyContainer from "./components/CopyContainer"
import Highlight from "./components/Highlight"
import Creed from "./components/Creed"

// Assets
import WelcomeImg from "../../../../assets/miscellaneous/welcome.jpg"

const Section = styled.section`
  padding-top: 10rem;
  padding-bottom: 10rem;

  img {
    width: 100%;
    height: 100%;
  }
`

export default function Welcome() {
  return (
    <Section>
      <BaseContainer>
        <img src={WelcomeImg} alt="Seja bem-vindo(a)" loading="lazy" />
        <CopyContainer />
      </BaseContainer>
      <Highlight />
      <Creed />
    </Section>
  )
}
